// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  attractionRequest: ['data'],
  attractionSuccess: ['data'],
  attractionFailure: ['err'],

  placeRequest: ['data'],
  placeSuccess: ['data'],
  placeFailure: ['err'],

  getPlacesV2Request: ['data'],
  getPlacesV2Success: ['data'],
  getPlacesV2Failure: ['err'],

  attractionDetailRequest: ['data'],
  attractionDetailSuccess: ['data'],
  attractionDetailFailure: ['err'],

  placeDetailRequest: ['data'],
  placeDetailSuccess: ['data'],
  placeDetailFailure: ['err'],

  attractionUpdateRequest: ['data'],
  attractionUpdateSuccess: ['data'],
  attractionUpdateFailure: ['err'],

  attractionClearCacheRequest: null,
  attractionClearCacheSuccess: null,
  attractionClearCacheFailure: ['err'],

  attractionSearchRequest: ['data'],
  attractionSearchSuccess: ['data'],
  attractionSearchFailure: ['err'],

  placeSearchRequest: ['data'],
  placeSearchSuccess: ['data'],
  placeSearchFailure: ['err'],

  downloadAttractionDataRequest: ['filter'],
  downloadAttractionDataSuccess: null,
  downloadAttractionDataFailure: ['err']
})

export const AttractionTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  processing: false,
  data: [],
  dataSearch: [],
  err: null,
  success: false,
  detail: {}
})

/* ------------- Reducers ------------- */

export const request = (state: Object) =>
  state.merge({ fetching: true, success: false })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    data,
    err: null
  })

export const searchSuccess = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  processing: false,
  dataSearch: data,
  err: null
})

export const detailSuccess = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  processing: false,
  detail: data,
  err: null
})

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const changeRequest = (state: Object) =>
  state.merge({ processing: true, err: null, success: false })

export const changeSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    err: null,
    success: true
  })

export const clearSuccess = (state: Object) =>
state.merge({ fetching: false, err: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.ATTRACTION_REQUEST]: request,
  [Types.ATTRACTION_SUCCESS]: success,
  [Types.ATTRACTION_FAILURE]: failure,

  [Types.GET_PLACES_V2_REQUEST]: request,
  [Types.GET_PLACES_V2_SUCCESS]: success,
  [Types.GET_PLACES_V2_FAILURE]: failure,

  [Types.PLACE_REQUEST]: request,
  [Types.PLACE_SUCCESS]: success,
  [Types.PLACE_FAILURE]: failure,

  [Types.ATTRACTION_DETAIL_REQUEST]: request,
  [Types.ATTRACTION_DETAIL_SUCCESS]: detailSuccess,
  [Types.ATTRACTION_DETAIL_FAILURE]: failure,

  [Types.PLACE_DETAIL_REQUEST]: request,
  [Types.PLACE_DETAIL_SUCCESS]: detailSuccess,
  [Types.PLACE_DETAIL_FAILURE]: failure,

  [Types.ATTRACTION_UPDATE_REQUEST]: changeRequest,
  [Types.ATTRACTION_UPDATE_SUCCESS]: changeSuccess,
  [Types.ATTRACTION_UPDATE_FAILURE]: failure,

  [Types.ATTRACTION_CLEAR_CACHE_REQUEST]: request,
  [Types.ATTRACTION_CLEAR_CACHE_SUCCESS]: clearSuccess,
  [Types.ATTRACTION_CLEAR_CACHE_FAILURE]: failure,

  [Types.ATTRACTION_SEARCH_REQUEST]: request,
  [Types.ATTRACTION_SEARCH_SUCCESS]: searchSuccess,
  [Types.ATTRACTION_SEARCH_FAILURE]: failure,

  [Types.PLACE_SEARCH_REQUEST]: request,
  [Types.PLACE_SEARCH_SUCCESS]: searchSuccess,
  [Types.PLACE_SEARCH_FAILURE]: failure,

  [Types.DOWNLOAD_ATTRACTION_DATA_REQUEST]: request,
  [Types.DOWNLOAD_ATTRACTION_DATA_SUCCESS]: success,
  [Types.DOWNLOAD_ATTRACTION_DATA_FAILURE]: failure
})



// WEBPACK FOOTER //
// ./src/Redux/AttractionRedux.js